/**
 * Strips markdown formatting from text, returning plain text.
 * Removes headings, bold, italic, strikethrough, code, links, images,
 * blockquotes, list markers, horizontal rules, and collapses multiple newlines.
 */
export function stripMarkdown(text: string): string {
	return text
		.replace(/<!--[\s\S]*?-->/g, '')
		.replace(/<br\s*\/?>/gi, ' ')
		.replace(/^#{1,6}\s+/gm, '')
		.replace(/\*\*(.+?)\*\*/g, '$1')
		.replace(/\*(.+?)\*/g, '$1')
		.replace(/__(.+?)__/g, '$1')
		.replace(/(^|[^\w])_([^_\n]+)_(?=[^\w]|$)/g, '$1$2')
		.replace(/~~(.+?)~~/g, '$1')
		.replace(/`(.+?)`/g, '$1')
		.replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
		.replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
		.replace(/^>\s?/gm, '')
		.replace(/^[-*+]\s+/gm, '')
		.replace(/^\d+\.\s+/gm, '')
		.replace(/^---+$/gm, '')
		.replace(/\n{2,}/g, '\n')
		.trim();
}
